module.exports = __webpack_public_path__ + "img/0c535d70dae19d29b2c339135e2e7ebc.png";